import { Component, OnInit } from '@angular/core';
import { timer } from 'rxjs';
import { BrokerService } from 'src/app/core/services/broker.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { RoutingService } from 'src/app/core/services/routing.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';

@Component({
  selector: 'app-confirm-telephone',
  templateUrl: './confirm-telephone.component.html',
  styleUrls: ['./confirm-telephone.component.scss']
})
export class ConfirmTelephoneComponent implements OnInit {

  // public step = 1;
  public haveMinHeight = true;
  public code = '';
  public timerCode: number = 90;
  public seconds: number = 0;
  public minutes: number = 0;
  public source = timer(0, 1000);
  public clock: any;
  public loadSendCode = false;
  public tryValidateCode = 0;
  public waitCode = 0;
  public isSendCode: boolean = false;
  public errorCode = false;
  public errorSendCode = false;
  public errorValidateCode = false;
  public retryIntention = 0;
  public failIntention = false;
  public isLoadApplyPadYa: boolean = false;
  public isLoadSaveIntention: boolean = false;
  public canCallApplyPadYa: boolean = true;

  constructor(public load: ModalService, public sesion: SesionService, public routing: RoutingService, private readonly dataLayer: DataLayersService, public utilities: UtilitiesService, public broker: BrokerService) { }

  ngOnInit(): void {
  }

  ngAfterViewChecked() {
    // let isMobile = window.innerWidth <= 768;
    // if (this.step == 3 && isMobile && this.load.flowConfirmTelephone == 'pad') {
    //   this.haveMinHeight = false;
    // } else {
    //   this.haveMinHeight = true;
    // }
  }

  nextNumCode(event: Event, del: boolean = false) {
    let element = (event.target as HTMLInputElement);
    if (!del) {
      if ((event as InputEvent).inputType == "deleteContentBackward") {
        element.value = '';
        let previous = element.previousElementSibling as HTMLElement;
        previous.focus();
      } else {
        let next = element.nextElementSibling as HTMLInputElement;
        next.value = '';
        if (element.value == '') {
          let previous = element.previousElementSibling as HTMLElement;
          previous.focus();
        } else {
          next.focus();
        }
      }
    } else {
      if ((event as KeyboardEvent).key == "Backspace" && element.value == '') {
        let previous = element.previousElementSibling as HTMLElement;
        previous.focus();
      }
    }
  }

  isValidCode() {
    let valid = false;
    document.querySelectorAll(".code-cel > input").forEach((ele: Element) => {
      if ((ele as HTMLInputElement).value == '') {
        valid = false;
        return false;
      } else {
        valid = true;
        return true;
      }
    });
    return valid;
  }

  sendCode(retry: boolean = false) {
    this.loadSendCode = true;
    this.errorSendCode = false;
    this.broker.createValidation(this.sesion.validatedPhone).subscribe({
      next: (res: any) => {
        if (res.message == 'Codigo OTP enviado!') {
          if (!retry) {
            this.nextStep();
          }
        } else if (res.message == 'Numero de intentos superado') {
          this.load.semiValidPhone = true;
          this.nextStep(3);
        }
        this.startTimer();
        this.loadSendCode = false;
      },
      error: (err: any) => {
        this.load.semiValidPhone = true;
        this.nextStep(3);
        this.errorSendCode = true;
        this.loadSendCode = false;
      }
    });
  }

  validateCode() {
    let code = '';
    document.querySelectorAll(".code-cel > input").forEach((ele: Element) => {
      code += (ele as HTMLInputElement).value;
    });
    this.tryValidateCode++;
    if (this.isValidCode()) {
      this.loadSendCode = true;
      this.errorValidateCode = false;
      this.errorCode = false;
      let numbers = document.querySelectorAll(".code-cel > input");
      numbers.forEach((element: Element) => {
        (element as HTMLInputElement).classList.remove("error-input");
      })
      this.broker.validateCode(code).subscribe({
        next: (res: any) => {
          if (res.message == 'Codigo OTP valido!') {
            this.sesion.dataUser.params[this.sesion.searchParamsIndexEcs('authenticationPhone')].value = true;
            this.nextStep();
          } else if (this.tryValidateCode == 2) {
            this.load.semiValidPhone = true;
            this.nextStep(3);
          } else {
            this.errorCode = true;
            let numbers = document.querySelectorAll(".code-cel > input");
            numbers.forEach((element: Element) => {
              (element as HTMLInputElement).classList.add("error-input");
            });
          }
          this.loadSendCode = false;
        },
        error: (err: any) => {
          if (this.tryValidateCode == 2) {
            this.load.semiValidPhone = true;
            this.nextStep(3);
          }
          this.errorCode = true;
          let numbers = document.querySelectorAll(".code-cel > input");
          numbers.forEach((element: Element) => {
            (element as HTMLInputElement).classList.add("error-input");
          });
          this.errorValidateCode = true;
          this.loadSendCode = false;
        }
      });
    }
  }

  nextStep(step: number = 0) {
    if (step == 0) {
      this.sesion.authenticationPhoneStep++;
    } else {
      this.sesion.authenticationPhoneStep = step;
    }
    if (step == 1) {
      this.load.semiValidPhone = false;
    }
  }

  showDate(end: any, now: any) {
    let distance = end - now;
    if (distance >= 0) {
      let _second = 1000;
      let _minute = _second * 60;
      this.seconds = Math.floor((distance % _minute) / _second);
      this.minutes = Math.floor((distance / _minute));
    } else {
      this.isSendCode = false;
      if (this.waitCode == 2) {
        this.load.semiValidPhone = true;
        this.nextStep(3);
      }
      this.clock.unsubscribe();
    }
  }

  startTimer() {
    this.isSendCode = true;
    this.waitCode++;
    let end = new Date();
    if (this.clock != undefined) {
      this.clock.unsubscribe();
    }
    end.setSeconds(end.getSeconds() + this.timerCode);
    this.clock = this.source.subscribe(t => {
      let now = new Date();
      this.showDate(end, now);
    });
  }

  finalStep() {
    if (this.load.flowConfirmTelephone == 'dash') {
      this.flowDash();
    }
    else if (this.load.flowConfirmTelephone == 'pad') {
      this.flowPad();
    }
  }

  flowDash() {
    this.dataLayer.dl_eventoGA4_menu_dashboard(this.load.botonDashHistory, 'Midatacrédito');
    this.routing.redirectAllAccess('0', '/historico');
    this.load.closeConfirmTel();
  }

  flowPad() {
    if (!this.failIntention) {
      this.isLoadSaveIntention = true;
      this.failIntention = false;
      let dataUTM = this.utilities.getDataUTM();
      this.retryIntention = 0;
      let req = {
        "authenticationPhone": this.sesion.searchParamsEcs("authenticationPhone").value,
        "sourceWallet": this.load.debtSerlefin.fuenteCartera, //fuenteCartera
        "companyName": this.load.debtSerlefin.originador, //originador
        "idObligation": this.load.debtSerlefin.idObligacion, //idObligacion
        "delinquencyInDays": this.load.debtSerlefin.diasMora, //diasMora
        "totalBalance": this.load.debtSerlefin.saldoTotal, //saldoTotal
        "discount": this.load.debtSerlefin.descuento, //descuento
        "status": this.load.debtSerlefin.estado, //estado
        "utmSource": dataUTM.sourceOfTraffic, //utmSource
        "utmMedium": dataUTM.mediumOfTraffic, //utmMedium
        "utmCampaign": dataUTM.campaignOfTraffic, //utmCampaign
        "location": this.load.debtSerlefin.localizacion, //token
        "token": this.load.debtSerlefin.Token //token
      }
      this.broker.saveIntentionPad(req).subscribe({
        next: (res: any) => {
          if (res.status == 0) {
            this.isLoadSaveIntention = false;
            window.open(this.load.debtSerlefin.Url, '_self');
            this.load.closeConfirmTel();
          } else {
            this.retryIntention++;
            this.retryIntentionPad(req);
          }
        }, error: (error: any) => {
          this.retryIntention++;
          this.retryIntentionPad(req);
        }
      });
    } else {
      this.load.closeConfirmTel();
    }
  }

  retryIntentionPad(req: any) {
    if (this.retryIntention <= 2) {
      this.broker.saveIntentionPad(req).subscribe({
        next: (res: any) => {
          if (res.status == 0) {
            this.isLoadSaveIntention = false;
            window.open(this.load.debtSerlefin.Url, '_self');
            this.load.closeConfirmTel();
          } else {
            this.retryIntention++;
            if (this.retryIntention > 2) {
              this.failIntention = true;
              this.isLoadSaveIntention = false;
            } else {
              this.retryIntentionPad(req);
            }
          }
        }, error: (error: any) => {
          this.retryIntention++;
          if (this.retryIntention > 2) {
            this.failIntention = true;
            this.isLoadSaveIntention = false;
          } else {
            this.retryIntentionPad(req);
          }
        }
      });
    }
  }

  closeConfirmTel() {
    if (this.load.flowConfirmTelephone == 'dash') {
      this.flowDash();
    }
    else if (this.load.flowConfirmTelephone == 'pad') {
      this.load.closeConfirmTel();
    }
  }
}

